<template>
  <div>
    <v-card>
      <v-card-title class="justify-center" style="background-color: #e6e6e6;">
        <v-icon left>school</v-icon>
        Sondagem/Infantil
      </v-card-title>

      <v-row class="mt-3 px-5">
        <v-col cols="3">
          <v-text-field
            v-model="nomeAluno"
            @input="debounceFilterNomeAluno()"
            label="Nome do aluno"
            dense
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="2">
          <v-text-field
            v-model="raAluno"
            @input="debounceFilterRaAluno()"
            label="RA Aluno"
            dense
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="2">
          <v-select
            label="Ano Escolar"
            @change="filtrarAnoEscolar()"
            v-model="anoEscolarSelecionado"
            :items="anoEscolar"
            dense
            outlined
          ></v-select>
        </v-col>

        <v-col cols="2">
          <v-select
            label="Ano Letivo"
            @change="filtrarAnoLetivo()"
            v-model="anoLetivoSelecionado"
            :items="anoLetivo"
            dense
            outlined
          ></v-select>
        </v-col>

        <v-col cols="2">
          <v-select
            label="Turma"
            @change="filtrarTurma()"
            v-model="turmaSelecionada"
            :items="turma"
            dense
            outlined
          ></v-select>
        </v-col>

        <v-col cols="1" class="d-flex justify-center pa-1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" dark fab color="blue" class="mr-5" @click="modalCadastrarAluno()">
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <span>Cadastrar</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalElements"
        :footer-props="footerProps"
        :items-per-page="footerProps.itemsPerPage"
        class="elevation-1"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :loading="carregandoArq"
                :disabled="carregandoArq"
                @click="loader = 'carregandoArq'"
                icon
                v-on="on"
              >
                <v-icon color="green" @click="baixar(item)"> mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Baixar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon style="cursor: pointer;" color="red" @click="modalDeletarAluno(item)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <span>Deletar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <DeletarAluno :show="showDeletarAluno" :item="itemParaDeletar" @fechar="fecharDeletarAluno" />
    <CadastrarAluno
      :show="showCadastrarAluno"
      @fechar="fecharCadastrarAluno"
      @recarregarItensTabela="recarregarItensTabela"
    />
  </div>
</template>

<script>
import CadastrarAluno from "@/views/SondagemInfantil/CadastrarAluno";
import DeletarAluno from "@/views/SondagemInfantil/DeletarAluno";
import SondagemInfantilService from "@/service/SondagemInfantilService";
import ArquivoService from "@/service/ArquivoService";
import _ from "lodash";

export default {
  components: { DeletarAluno, CadastrarAluno },
  data() {
    return {
      options: {
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      totalElements: null,
      itemParaDeletar: null,
      anoAtual: undefined,
      debounceFilterNomeAluno: null,
      debounceFilterRaAluno: null,

      response: undefined,
      nomeAluno: "",
      raAluno: "",
      anoEscolarSelecionado: undefined,
      anoEscolarRequest: "",
      anoLetivoSelecionado: "Todos",
      turmaSelecionada: "Todas",
      anoEscolar: [],
      anos: [],
      anoLetivo: [],
      turma: [],
      items: [],
      showDeletarAluno: false,
      showCadastrarAluno: false,

      footerProps: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [5, 10, 20, 50],
      },
      headers: [
        {
          text: "ID",
          value: "id",
          align: "start",
        },
        {
          text: "Nome do Aluno",
          value: "nomeAluno",
          align: "center",
          width: "400",
        },
        {
          text: "RA Aluno",
          value: "raAluno",
          align: "center",
        },
        {
          text: "Ano Letivo",
          value: "anoLetivo",
          align: "center",
        },
        {
          text: "Ano Escolar",
          value: "anoEscolar",
          align: "center",
        },
        {
          text: "Turma",
          value: "turma",
          align: "center",
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
        },
      ],

      carregandoArq: false,
    };
  },

  methods: {
    modalCadastrarAluno() {
      this.showCadastrarAluno = true;
    },

    baixar(item) {
      this.carregandoArq = true;
      SondagemInfantilService.baixarArquivo(item.id)
        .then(({ data }) => {
          let byte = ArquivoService.base64ToArrayBuffer(data);
          let nomeArquivo = item.nomeAluno.replace(/ /g, "_");
          this.saveByteArray(nomeArquivo, byte, item.contentType);
        })
        .finally(() => {
          this.carregandoArq = false;
        });
    },

    saveByteArray(reportName, byte, type) {
      var blob = new Blob([byte], { type: type });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    },

    fecharDeletarAluno() {
      this.filtrar();

      this.showDeletarAluno = false;
    },

    fecharCadastrarAluno() {
      this.showCadastrarAluno = false;
    },

    recarregarItensTabela() {
      this.filtrar();
    },

    modalDeletarAluno(item) {
      this.itemParaDeletar = item;
      this.showDeletarAluno = true;
    },

    filtrarTurma() {
      this.filtrar();
    },

    filtrarAnoLetivo() {
      this.filtrar();
    },

    async filtrarAnoEscolar() {
      this.anoEscolarRequest = this.anoEscolarSelecionado.replace("°", "");

      if (this.anoEscolarSelecionado === "Todos") this.anoEscolarRequest = "";

      await this.filtrar();
    },

    async filtrarCamposTexto() {
      this.options.page = 1;
      await this.filtrar();
    },

    async fetchApi(anoLetivo, anoEscolar, nomeAluno, raAluno, turma, size, page) {
      try {
        const response = await SondagemInfantilService.getAll(
          anoLetivo,
          anoEscolar,
          nomeAluno,
          raAluno,
          turma,
          size,
          page
        );

        this.items = response.data.content;
        this.totalElements = response.data.totalElements;
      } catch (error) {
        console.error(error);
      }
    },

    async filtrar() {
      await this.fetchApi(
        this.anoLetivoSelecionado !== "Todos" ? this.anoLetivoSelecionado : "",
        this.anoEscolarSelecionado !== "Todos" ? this.anoEscolarRequest : "",
        this.nomeAluno.toUpperCase(),
        this.raAluno.length > 0 ? this.raAluno : "",
        this.turmaSelecionada !== "Todas" ? this.turmaSelecionada : "",
        this.options.itemsPerPage,
        this.options.page - 1
      );
    },

    setAnos() {
      this.anoEscolar = ["1°", "2°", "3°", "4°", "5°", "6°", "7°", "8°", "9°"];
      this.anoEscolar.unshift("Todos");

      this.anoEscolarSelecionado = this.anoEscolar[0];
    },

    setTurma() {
      this.turma = ["A", "B", "C", "D", "E", "F", "G", "H"];
      this.turma.unshift("Todas");
    },

    setAnoLetivo() {
      for (let ano = 2020; ano <= this.anoAtual; ano++) {
        this.anoLetivo.push(ano.toString());
      }

      this.anoLetivo.unshift("Todos");
    },
  },

  watch: {
    options: _.debounce(function() {
      this.filtrar();
    }, 250),
  },

  async created() {
    try {
      this.anoAtual = new Date().getFullYear();

      this.setAnos();
      this.setTurma();
      this.setAnoLetivo();
      this.debounceFilterNomeAluno = _.debounce(this.filtrarCamposTexto, 300);
      this.debounceFilterRaAluno = _.debounce(this.filtrarCamposTexto, 300);

      this.filtrar();
    } catch (error) {
      console.error(error);
    }
  },
};
</script>

<style></style>
